module.exports = __webpack_public_path__ + "static/media/gpp.e7417bb3.png";